import { MainBsiManager } from '@wix/bsi-manager';
import { getCommonConfig } from './common-config';
import { getConsentPolicy } from './consent-policy';
import { generateGuid } from './utils/guid-utils';
import { getCookieDomain } from './utils/cookie-utils';

export const bsiManager = MainBsiManager.create(
  {
    generateGuid,
    getCommonConfig,
    getConsentPolicy,
  },
  { cookieDomain: getCookieDomain() },
);
